/* eslint-disable react/prop-types */
import { type PositionFilterResults } from 'services'
import React from 'react'
import { PositionsList, PositionsStack } from 'components'

interface PositionsStackProps {
  parsedOrgId?: number
  personId?: number
  loading: boolean
  positions: PositionFilterResults
  triggerReload: () => Promise<void>
  paginatedMode: boolean
  changePage?: (page: number) => Promise<void>
}

export const PositionsListOrStack: React.FC<PositionsStackProps> = React.memo(
  ({ parsedOrgId, personId, positions, loading, triggerReload, paginatedMode, changePage = async () => { await Promise.resolve() } }) => {
    return !paginatedMode
      ? (<PositionsStack positions={positions.data} loading={loading} orgId={parsedOrgId} triggerReload={triggerReload}/>)
      : (<PositionsList positions={positions} loading={loading} orgId={parsedOrgId} triggerReload={triggerReload} changePage={changePage} />)
  }
)

PositionsListOrStack.displayName = 'PositionsListOrStack'
